/* File Drag Drop - 檔案拖曳 v1.0.0
 * Copyright © 2022 Reginna(https://github.com/reginna-chao)
 * MIT License
 */

(function(window, document) {

	let windowIsDetected = false; // 是否有監測 windows
	let lastTarget = null;

	const clone = {}; // 複製Input快取，避免按上傳後取消

	const dropFileBox = []; // 紀錄 Dropbox 物件

	// 預設錯誤訊息(EN)
	const defaultMsg = {
		multiple: 'Oops, you dragged more than one file!<br>Please only drag your desired file.',
		typeImg: 'IMAGE',
		typeComma: ', ',
		typeOr: ' or ',
		typeTextBefore: 'Make sure to upload a ',
		typeTextAfter: ' file.<br>please try again!',
		sizeBefore: 'Sorry, your attachment for proof of purchase is larger than ',
		sizeAfter: ', <br>please try again!'
	}

	// TW
	// const msgTw = {
	// 	multiple: '您同時拖曳多個檔案，只能選取一個檔案。',
	// 	typeImg: '圖片',
	// 	typeComma: '、',
	// 	typeOr: '或',
	// 	typeTextBefore: '請上傳',
	// 	typeTextAfter: '檔案。',
	// 	sizeBefore: '您上傳的檔案過大，請上傳',
	// 	sizeAfter: '以下'
	// }

	/* ---------------------------------------- [START] DropFile Class */
	class FileDrop {
		constructor (selector, ...args) {
			// 避免不支援狀況
			if (!(window.File && window.FileList && window.FileReader)) {
				return false;
			}

			// 預設變數
			const defualtOpt = {
				inputEl: selector, // Input
				wrapperEl: selector.parentElement, // 外層
				dragAreaEl: selector.parentElement, // 可拖曳放置的區域
				dropTipEl: null, // 拖曳的提醒物件
				showEl: selector.parentElement, // 顯示圖片區域
				delEl: null, // 刪除按鈕
				selectedClass: 'is-selected',
				dragClass: 'is-drag',
				dropReadyClass: 'is-drop-ready',
				imgLoadingClass: 'is-img-loading',
				on: {}
			}

			// 預設變數 - 事件
			const eventOpt = {
				msg: buildAlert
			}

			// 合併變數
			const opt = {
				...defualtOpt,
				...args[0]
			}

			// 合併事件
			if (args[0].on) {
				opt.on = {
					...eventOpt,
					...args[0].on
				}
			} else {
				opt.on = eventOpt
			}

			this.params = opt;

			// 警告相關
			this.alert = opt.on.msg;
			this.alertMsg = defaultMsg;

			// 開放設置語系
			this.lang = this.lang;

			this.init();
		}

		init () {
			const _this = this;
			const params = _this.params;

			this.rule = _this.inputCheckRule(params.inputEl);

			// Input物件
			on(params.inputEl, 'change', _this.inputChange.bind(_this), false);
			on(params.inputEl, 'click', _this.inputClone, false);

			// 刪除物件
			if (params.delEl) {
				on(params.delEl, 'click', _this.inputClean.bind(_this), false);
			}

			// Drag & Drop
			const xhr = new XMLHttpRequest();
			if (xhr.upload) {
				// on(params.dragAreaEl, 'dragover', _this.fileDragHover.bind(_this), false);
				// on(params.dragAreaEl, 'dragleave', _this.fileDragHover.bind(_this), false);
				on(params.dragAreaEl, 'drop', _this.inputChange.bind(_this), false);

				if (!windowIsDetected) {
					windowIsDetected = true;

					on(window, 'dragover', _this.fileDragHoverWindow.bind(_this), false);
					on(window, 'dragenter', _this.fileDragHoverWindow.bind(_this), false);
					on(window, 'dragleave', _this.fileDragHoverWindow.bind(_this), false);
					on(window, 'drop', _this.fileDragHoverWindow.bind(_this), false);

					// 貼上 (需要 windowIsDetected 變數，所以寫這)
					on(window, 'paste', _this.paste.bind(_this), false);
				}
			}
			dropFileBox.push(_this); // 紀錄物件(window 監聽會需要)

			// FINAL: 記錄在物件上 & 觸發 init
			params.inputEl.fileDrop = _this;
			params.inputEl.dispatchEvent(new CustomEvent('fileDrop:init'));
		}

		lang (lang) {
			if (typeof lang === 'object') {
				this.alertMsg = {
					...lang
				}
			}
		}

		inputCheckRule (el) {
			const input = el;
			const inputOpt = {
				size: null, // 檔案限制大小，預設為無限制 (寫於data-size)
				accept: null // 接受的檔案類型，預設為無限制(寫於<input type="file"> accept)
			}
			
			// 檔案大小 | Size
			const size = input.dataset['size'] || input.getAttribute('data-size');
			if (size) {
				const exponent = size.match(/KB/gi)
					? 1
					: size.match(/MB/gi)
						? 2
						: size.match(/GB/gi)
							? 3
							: 0;

				inputOpt.size = parseFloat(size) * Math.pow(1024, exponent);
				inputOpt.sizeText = size;
			}

			// 接受檔案類型 | Accept
			const accept = input.accept || input.getAttribute('accept');
			if (accept) {
				inputOpt.accept = accept.replace(/\*/g, '');
			}

			el.opt = inputOpt;

			return inputOpt;
		}

		inputChange (e) {
			const _this =  this;
			const params =  _this.params;
			const alertMsg = _this.alertMsg;
			const rule = _this.rule;

			const target = e.target;

			// Change || Drop || Paste
			const files = target.files || (e.dataTransfer ? e.dataTransfer.files : null) || e.clipboardData.files;

			// 移除 Drag Drop 提示
			if(e.type === 'drop'){
				_this.fileDragHoverWindow(e);
			}

			if (files.length === 0) {
				// 如果沒有檔案 (按取消)
				if(e.type === 'change' && clone[target.id] !== null){
					// Clone有值 => 複製原本的
					var cloneInput = clone[target.id];

					// 複製事件
					on(cloneInput, 'change', _this.inputChange.bind(_this), false);
					on(cloneInput, 'click', _this.inputClone, false);
					target.parentNode.replaceChild(cloneInput, target);

					params.inputEl = cloneInput; // 更新項目
				}

				return false;
			}

			// 檢測：單複數檔案
			if (!(target.multiple || target.getAttribute('multiple') === undefined) && files.length > 1) {
				// 如果是單數，但得到複數檔案
				// 錯誤訊息：「您同時拖曳多個檔案，只能選取一張相片。」
				_this.alert('error', alertMsg.multiple);
				return false;
			}

			let isError = false;

			[].forEach.call(files, (file, i) => {
				// 檢測：檔案類型不符
				// 拖入非指定檔為 -1
				// 拖入資料夾、特殊檔為 0
				if ( file.type === '' || ( rule.accept.indexOf(file.type) === -1 && file.type.indexOf(rule.accept) === -1 ) ) {
					const acceptFiles = rule.accept.replace(/\s+/g, "").split(',');
					const acceptType = [];
					let alertText = "";

					for(let i = 0; i < acceptFiles.length; i++){
						if(acceptFiles[i] === 'image/'){
							acceptType.push(alertMsg.typeImg);
							break;
						}else if(acceptFiles[i] === 'image/jpeg'){
							acceptType.push('JPG');
							acceptType.push('JPEG');
						}else if(acceptFiles[i] === 'image/tiff'){
							acceptType.push('TIF');
						}else{
							acceptType.push(acceptFiles[i].split('/')[1].toUpperCase());
						}
					}

					for (let i = 0; i < acceptType.length; i++) {
						alertText = alertText + acceptType[i];

						if(acceptType.length > 1){
							if(i < acceptType.length - 2){
								alertText = alertText + alertMsg.typeComma
							}else if(i == acceptType.length - 2){
								alertText = alertText + alertMsg.typeOr
							}
						}
					}

					// 錯誤訊息：「請上傳JPG或PNG檔案。」
					alertText = alertMsg.typeTextBefore + alertText + alertMsg.typeTextAfter;

					_this.alert('error', alertText);
					_this.inputClean();
					
					isError = true;
					return;
				}

				// 檢測：檔案大小
				if (rule.size != null && files[0].size > rule.size) {
					// 錯誤訊息：「您上傳的檔案過大，請上傳3MB以下。」
					const alertText = alertMsg.sizeBefore + rule.sizeText + alertMsg.sizeAfter;

					_this.alert('error', alertText);
					_this.inputClean();

					isError = true;
					return;
				}

				_this.parseImg(file);
			});

			if (isError) {
				return false;
			}

			// 拖曳時同步input FileList（只有Drop事件）
			// Reference: https://stackoverflow.com/a/47522812
			if(e.type ==='drop' || e.type ==='paste'){
				params.inputEl.files = files;
				params.inputEl.dispatchEvent(new Event('change'));
			}
		}

		// 複製Input (避免點擊取消 → 檔案被移除)
		// https://jsfiddle.net/mgpwr1as
		inputClone (event) {
			const fileElement = event.target;
			if (fileElement.value !== '') {
				clone[fileElement.id] = fileElement.cloneNode(true); // Copying clone
			} else {
				// 沒值則清除
				clone[fileElement.id] = null
			}
		}

		// 清除input
		inputClean () {
			const params = this.params;

			params.inputEl.value = '';
			params.showEl.innerHTML = '';
			params.wrapperEl.classList.remove(params.selectedClass);
		}

		// Show Image
		parseImg (file) {
			const params = this.params;

			// Is selected status
			params.wrapperEl.classList.add(params.selectedClass);
			params.showEl.classList.add(params.imgLoadingClass);
						
			// Read File
			const reader = new FileReader();
			reader.onload = (e) => {
				var resultUrl = e.target.result;

				var img = document.createElement('img');
				img.onload = function() {
					params.showEl.classList.remove(params.imgLoadingClass);
				}
				img.src = resultUrl;

				params.showEl.innerHTML = '';
				params.showEl.appendChild(img);
			}
			reader.readAsDataURL(file);
		}

		// fileDragHover (e) {
		// 	console.log('fileDragHover', e.type);
		// 	e.stopPropagation();
		// 	e.preventDefault();

		// 	if (e.type === 'dragover') {
		// 		this.params.wrapperEl.classList.add(this.params.dropReadyClass);

		// 		this.params.dropTipEl
		// 	} else {
		// 		this.params.wrapperEl.classList.remove(this.params.dropReadyClass);
		// 	}
		// }

		fileDragHoverWindow (e) {
			e.stopPropagation();
			e.preventDefault();

			if (!isFile(e)) {
				return false
			}

			if (e.type == 'dragover') {
				return false
			}

			const _this = this;

			// dragenter
			if (e.type == 'dragenter') {
				lastTarget = e.target;

				dropFileBox.forEach((item) => {
					if (item.params.inputEl.disabled) {
						return
					}

					// 增加class，提示可以拖曳放置的區塊
					item.params.wrapperEl.classList.add(_this.params.dragClass);
					
					// 判斷是否在範圍內 => 增加「可放置」區塊
					if (lastTarget === item.params.dragAreaEl) {
						item.params.wrapperEl.classList.add(_this.params.dropReadyClass);
					} else {
						item.params.wrapperEl.classList.remove(_this.params.dropReadyClass);
					}
				});

				return false;
			}

			// dragleave
			if (e.target === document || e.target === lastTarget) {
				dropFileBox.forEach((item) => {
					item.params.wrapperEl.classList.remove(_this.params.dragClass);
					item.params.wrapperEl.classList.remove(_this.params.dropReadyClass);
				});
			}
		}

		paste (e) {
			// https://www.telerik.com/kendo-react-ui/knowledge-base/upload-paste-image-from-clipboard/
			// 有檔案
			if (e.clipboardData.files.length === 1) {
				const file = e.clipboardData.files[0];

				// 直接擋下非圖片、非符合資格檔案
				if (file.type !== '' && (this.rule.accept.indexOf(file.type) === 0 || file.type.indexOf(this.rule.accept) === 0)) {
					this.inputChange(e);
				}
			}
		}
	}

	window.FileDrop = FileDrop;
	/* ---------------------------------------- [END] DropFile Class */

	

	/* ---------------------------------------- [START] Tool */
	/* ---------------------------------------- [START] Window EventListener */
	function on(target, event, func, option) {
		target = target || window;
		if (window.addEventListener) {
			var opt = option || false;
			target.addEventListener(event, func, opt);
		} else {
			target.attachEvent('on' + event, func);
		}
	};

	function off(target, event, func) {
		target = target || window;
		if (window.addEventListener) target.removeEventListener(event, func, false);
		else target.detachEvent('on' + event, func);
	};
	/* ---------------------------------------- [END] Window EventListener */
	/* ---------------------------------------- [START] Is File */
	// 確認是否是檔案
	function isFile(evt) {
		var dt = evt.dataTransfer;
		for (var i = 0; i < dt.types.length; i++) {
			if (dt.types[i] === "Files") {
				return true;
			}
		}
		return false;
	}
	/* ---------------------------------------- [END] Is File */
	/* ---------------------------------------- [START] Alert */
	// 顯示警告視窗
	// Reference: https://stackoverflow.com/a/15466856
	function buildAlert(type, text){
		const el = document.createElement('div');
		const bgColor = type === 'error'
			? 'rgba(232, 28, 41, 0.9)'
			: type === 'success'
				? 'rgba(157, 201, 58, 0.9)'
				: 'rgba(0, 0, 0, 0.9)';
		
		el.setAttribute('style', `position: fixed; z-index: 1000; top: 50%; left: 50%; padding: 0.5rem 1rem; font-size: 1rem; color: #fff; background: ${bgColor}; border-radius: 0.3125rem; box-shadow: 0 0 0.3125rem rgba(0,0,0,0.3); transform: translate(-50%, -50%); animation: showAlert 3s forwards;`)
		el.classList.add('alert-msg');
		el.innerHTML = text;

		const style = document.createElement('style');
		const css = '@keyframes showAlert { 0% { opacity: 0; top: 40%; } 25%, 75% { opacity: 1; top: 50%; } 100% { opacity: 0; top: 40%; } }';
		el.appendChild(style);
		style.appendChild(document.createTextNode(css));

		setTimeout(function(){
			el.parentNode.removeChild(el);
		}, 5000);
		document.body.appendChild(el);
	}
	/* ---------------------------------------- [END] Alert */
	/* ---------------------------------------- [END] Tool */

	/* ---------------------------------------- [START] Build */
	function buildFileDrop() {
		const fileDrops = document.querySelectorAll('.js-drop-file');
		if (fileDrops.length) {
			fileDrops.forEach((item, index) => {
				const input = item.querySelector('input[type="file"]');

				const fd = new FileDrop(input, {
					wrapperEl: item,
					// dragAreaEl: item.parentElement,
					dragAreaEl: item,
					dropTipEl: item.querySelector('[data-drop-tip]'),
					showEl: item.querySelector('[data-img-preview]'),
					delEl: item.querySelector('[data-del]'),
					on: {
						msg (type, msg) {
							toast(type === 'error' ? type : 'info', msg, 5000);
						}
					}
				});
			});
		}
	}

	on(window, 'load', buildFileDrop);
	/* ---------------------------------------- [END] Build */
})(window, document);
